import { z } from 'zod'
import type { ShiftListParams } from './queries'

/** The shifts list lives in the URL; an invalid value falls back to the default instead of failing. */
export const SHIFT_PAGE_SIZES = [25, 50, 100] as const
type PageSize = (typeof SHIFT_PAGE_SIZES)[number]

export const shiftSearchSchema = z.object({
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z
    .number()
    .refine((n): n is PageSize => (SHIFT_PAGE_SIZES as readonly number[]).includes(n))
    .optional()
    .catch(undefined),
  status: z.enum(['OPEN', 'CLOSED']).optional().catch(undefined),
  terminalId: z.uuid().optional().catch(undefined),
})
export type ShiftSearch = z.infer<typeof shiftSearchSchema>

export function toShiftListQuery(search: ShiftSearch): ShiftListParams {
  return {
    page: search.page ?? 1,
    pageSize: search.pageSize ?? 25,
    status: search.status,
    terminalId: search.terminalId,
  }
}
